import { FormEvent, useState } from 'react'
import { Link } from 'react-router'
import { toast } from 'sonner'
import { cn } from '../lib/utils'
import { Input } from '../components/ui/input'
import { Button, buttonVariants } from '../components/ui/button'
import { submitRoboLabLogin } from '../lib/robolabx-login-catalog'
import { RobotLogo } from '../components/RobotLogo'

export const ADMIN_LOGIN_TITLE = 'Teacher & Admin Sign In'

export function AdminLoginPage() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    if (isSubmitting) return

    setIsSubmitting(true)

    try {
      await submitRoboLabLogin({
        username: username.trim(),
        password,
      })
      window.location.replace('/admin/usage')
    } catch {
      toast.error('Unable to sign in. Please check your details and try again.')
      setIsSubmitting(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 py-10 text-foreground">
      <div className="w-full max-w-[440px] rounded-base border-2 border-nb-border bg-secondary-bg p-7 nb-shadow">
        <div className="flex items-center gap-3">
          <RobotLogo className="h-12 w-12" />
          <div>
            <div className="font-heading text-lg leading-none">Robolab X</div>
            <h1 className="mt-2 font-heading text-[1.65rem] leading-tight">{ADMIN_LOGIN_TITLE}</h1>
          </div>
        </div>

        <form className="mt-7 flex flex-col gap-5" onSubmit={handleSubmit}>
          <div className="grid gap-2">
            <label className="text-sm font-heading" htmlFor="admin-username">
              Username
            </label>
            <Input
              id="admin-username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              placeholder="Enter username"
              autoComplete="username"
              className="h-11 text-sm"
            />
          </div>

          <div className="grid gap-2">
            <label className="text-sm font-heading" htmlFor="admin-password">
              Password
            </label>
            <Input
              id="admin-password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Enter password"
              autoComplete="current-password"
              className="h-11 text-sm"
            />
          </div>

          <Button type="submit" className="w-full text-sm" disabled={isSubmitting || !username.trim() || !password}>
            {isSubmitting ? 'Logging in...' : 'Log in'}
          </Button>
        </form>

        <div className="mt-6 rounded-base border-2 border-nb-border bg-secondary-bg p-4">
          <p className="text-sm font-heading text-foreground/65">Student sign in</p>
          <p className="mt-3 text-sm leading-relaxed text-foreground/80">
            Students use a separate friendly sign-in flow.
          </p>
          <Link to="/login" className={cn(buttonVariants({ variant: 'neutral' }), 'mt-4 flex w-full')}>
            Go to student sign in
          </Link>
        </div>
      </div>
    </div>
  )
}
